module.exports = __webpack_public_path__ + "static/img/loading.3c44faf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newoeimg/loading.gif
// module id = fl6e
// module chunks = 21